import { api } from './api.js';

// 041: typed fetchers for the geo reference lookups that back the location
// form's cascading country → state → city selects.

export interface GeoOption {
  id: string;
  name: string;
}

export async function getCountries(): Promise<GeoOption[]> {
  const res = await api.get<{ items: GeoOption[] }>('/geo/countries');
  return res.items;
}

export async function getStates(countryId: string): Promise<GeoOption[]> {
  const res = await api.get<{ items: GeoOption[] }>(
    `/geo/states?country_id=${encodeURIComponent(countryId)}`,
  );
  return res.items;
}

export async function getCities(stateId: string): Promise<GeoOption[]> {
  const res = await api.get<{ items: GeoOption[] }>(
    `/geo/cities?state_id=${encodeURIComponent(stateId)}`,
  );
  return res.items;
}
